// Pricing for bag items and orders. Pure (no Firebase), so it can be tested
// and shared by the customizer, the bag and postOrder.

// The pieces a bag item is actually charged for. An only_kurta item keeps a
// "Pajama" fabric for the preview picture; unless the customer added the
// pajama (buyPajama), it is not sold and must not be priced. Order 1792933261859M
// (25 Oct 2026) paid for a pajama it never ordered because this summed every piece.
export const chargedPieces = (a) =>
    Object.keys((a && a.fabric) || {}).filter((piece) => !(a.category === "only_kurta" && !a.buyPajama && piece === "Pajama"))

export const calPrice = (a)=>{
        let p = 0
        let D = Number(0)
        chargedPieces(a).forEach((element)=>{
            if(a["fabric"][element]["discount"]){
                const perc = Number(a["fabric"][element]["discount"])
                D = D + (Number(a["fabric"][element]["price"])*( perc/100 ) )
            }
            p+=Number(a["fabric"][element]["price"])
        }) 
        if (Array.isArray(a.embroidery) && a.embroidery.length > 0) {
            a.embroidery.forEach((emb) => {
                if (!emb) return;
                const resolvedPrice = Number(emb._resolvedPrice);
                if (!Number.isNaN(resolvedPrice) && resolvedPrice > 0) {
                    p += resolvedPrice;
                    return;
                }
                if (Array.isArray(emb.values) && emb.values.length > 0) {
                    let collectionTotal = 0;
                    emb.values.forEach((val) => {
                        const vPrice = Number(val && val.price != null ? val.price : 0);
                        if (!Number.isNaN(vPrice) && vPrice > 0) {
                            collectionTotal += vPrice;
                        }
                    });
                    if (collectionTotal > 0) {
                        p += collectionTotal;
                        return;
                    }
                }
                if (emb.price != null && emb.price !== "") {
                    p += Number(emb.price) || 0;
                }
            });
        }
        return [p, D]
    }

// A Firestore DocumentReference or snapshot copied into the bag becomes a
// huge object of SDK internals once it goes through localStorage. Keep only
// its path; nothing reads more than that.
export const isFirestoreJunk = (v) => v && typeof v === "object" && !Array.isArray(v) && ("_delegate" in v || "_key" in v || "_userDataWriter" in v);
export const firestorePath = (v) => {
    try {
        if (typeof v.path === "string") return v.path;
        const seg = v?._delegate?._key?.path?.segments || v?._key?.path?.segments;
        const off = v?._delegate?._key?.path?.offset ?? v?._key?.path?.offset ?? 0;
        if (Array.isArray(seg)) return seg.slice(off).join("/");
    } catch (e) { /* fall through */ }
    return null;
};

/**
 * One bag item as it should be charged and stored: the price and discount
 * worked out again for custom items whose pieces changed meaning (a kurta
 * without its pajama), and Firestore objects reduced to their path.
 */
export const repairCartItem = (item) => {
    if (!item || typeof item !== "object") return item;
    const out = { ...item };
    if (out.fabric && typeof out.fabric === "object") {
        out.fabric = Object.fromEntries(Object.entries(out.fabric).map(([piece, f]) => {
            if (!f || typeof f !== "object") return [piece, f];
            const g = { ...f };
            if (isFirestoreJunk(g.style)) g.style = firestorePath(g.style);
            return [piece, g];
        }));
        // Custom garments only (presets have item_type); repricing is safe
        // because calPrice reads the same fabric and embroidery prices.
        if (!Object.prototype.hasOwnProperty.call(out, "item_type") && out.category === "only_kurta" && !out.buyPajama) {
            const [price, discount] = calPrice(out);
            if (price > 0) { out.price = price; out.discount = discount; }
        }
    }
    return out;
};
export const repairCart = (items) => (Array.isArray(items) ? items.map(repairCartItem) : items);

/**
 * What each item of an order really cost, so the bill and invoice add up to
 * the order value the customer agreed to: the item's own discount first, then
 * its share of the cart-level savings (coupon, coins, the prepaid offer). The
 * bill used to carry the gross price (₹6,502 on a ₹5,948 order).
 */
export const allocateOrderValue = (orders, orderValueIn) => {
    const list = Array.isArray(orders) ? orders : [];
    const itemNet = (doc) => {
        if (doc?.item_type === 0) return 250;
        const gross = Number(doc?.price || 0);
        const disc = Number(doc?.discount || 0);
        const isPreset = Object.prototype.hasOwnProperty.call(doc || {}, "item_type");
        return Math.max(0, isPreset ? gross - (gross * disc) / 100 : gross - disc);
    };
    const nets = list.map(itemNet);
    const netSum = nets.reduce((a, b) => a + b, 0);
    const orderValue = Number(orderValueIn || 0);
    const scale = netSum > 0 && orderValue > 0 ? orderValue / netSum : 1;
    const totals = nets.map((n) => Math.round(n * scale));
    if (totals.length && orderValue > 0) totals[totals.length - 1] += Math.round(orderValue) - totals.reduce((a, b) => a + b, 0);
    return totals;
};
